/**
 * Service Icons Mapping
 * Maps service names and categories to Lucide React icons
 */
import {
  Home,
  Wrench,
  Zap,
  Droplets,
  Paintbrush,
  Car,
  TreePine,
  Thermometer,
  Sparkles,
  LayoutGrid,
  Palette,
  Hammer,
  Axe,
  Building,
  Trees,
  DoorOpen,
  Cuboid,
  Bug,
  Shield,
  Package,
  Settings,
  Trash2,
  Plug,
  Sofa,
  Tv,
  Layers,
  Fan,
  Lightbulb,
  Battery,
  BatteryCharging,
  Wifi,
  Waves,
  ShowerHead,
  Flame,
  Wind,
  Snowflake,
  ThermometerSun,
  AirVent,
  Brush,
  Warehouse,
  Armchair,
  GlassWater,
  Cloudy,
  PaintBucket,
  PenTool,
  Ruler,
  HardHat,
  Construction,
  Fence,
  Container,
  Shovel,
  CloudRain,
  Flower2,
  Scissors,
  Sprout,
  PanelTop,
  Frame,
  Square,
  BrickWall,
  Mountain,
  Rat,
  Search,
  Camera,
  Lock,
  Smartphone,
  Network,
  Truck,
  ArchiveRestore,
  CircleDot,
  Sun,
  Volume2,
  Box,
  Hand,
  Baby,
  MonitorSpeaker,
  Refrigerator,
  WashingMachine,
  SwimmingPool,
  SunMedium,
  CircuitBoard,
  Timer,
  CheckSquare,
  Cog,
} from 'lucide-react';

// Category Icons (main service categories)
export const CATEGORY_ICONS = {
  // Home Improvement & Repairs
  '🏠 Home Improvement & Repairs': Home,
  'Home Improvement & Repairs': Home,

  // Electrical Services
  '⚡ Electrical Services': Zap,
  'Electrical Services': Zap,

  // Plumbing Services
  '🚿 Plumbing Services': Droplets,
  'Plumbing Services': Droplets,

  // HVAC Services
  '❄️ HVAC Services': Thermometer,
  'HVAC Services': Thermometer,

  // Cleaning Services
  '🧹 Cleaning Services': Sparkles,
  'Cleaning Services': Sparkles,

  // Flooring Services
  '🪵 Flooring Services': LayoutGrid,
  'Flooring Services': LayoutGrid,

  // Painting & Finishing
  '🎨 Painting & Finishing': Palette,
  'Painting & Finishing': Palette,

  // Remodeling & Construction
  '🔨 Remodeling & Construction': Hammer,
  'Remodeling & Construction': Hammer,

  // Carpentry Services
  '🪚 Carpentry Services': Axe,
  'Carpentry Services': Axe,

  // Roofing & Exterior
  '🏠 Roofing & Exterior': Building,
  'Roofing & Exterior': Building,

  // Landscaping & Outdoor
  '🌳 Landscaping & Outdoor': Trees,
  'Landscaping & Outdoor': Trees,

  // Doors, Windows & Glass
  '🚪 Doors, Windows & Glass': DoorOpen,
  'Doors, Windows & Glass': DoorOpen,

  // Masonry & Concrete
  '🧱 Masonry & Concrete': Cuboid,
  'Masonry & Concrete': Cuboid,

  // Pest & Safety
  '🐛 Pest & Safety': Bug,
  'Pest & Safety': Bug,

  // Security & Smart Home
  '🔒 Security & Smart Home': Shield,
  'Security & Smart Home': Shield,

  // Moving & Storage
  '📦 Moving & Storage': Package,
  'Moving & Storage': Package,

  // Specialty Services
  '🔧 Specialty Services': Settings,
  'Specialty Services': Settings,

  // Junk Removal & Hauling
  '🗑️ Junk Removal & Hauling': Trash2,
  'Junk Removal & Hauling': Trash2,

  // Installation Services
  '🔌 Installation Services': Plug,
  'Installation Services': Plug,
};

// Individual Service Icons
export const SERVICE_ICONS = {
  // Home Improvement & Repairs
  'Handyman services': Wrench,
  'General home repairs': Home,
  'Drywall repair & installation': Square,
  'Door & window repair': DoorOpen,
  'Furniture assembly': Sofa,
  'TV mounting': Tv,
  'Shelving installation': Layers,
  'Caulking & sealing': PenTool,
  'Baby-proofing homes': Baby,

  // Electrical Services
  'Electrical repair': Zap,
  'Outlet & switch installation': Plug,
  'Lighting installation': Lightbulb,
  'Ceiling fan installation': Fan,
  'Panel upgrades': CircuitBoard,
  'Rewiring': Plug,
  'EV charger installation': BatteryCharging,
  'Smart home wiring': Wifi,
  'Generator installation': Battery,

  // Plumbing Services
  'Leak detection': Search,
  'Faucet repair & installation': Droplets,
  'Toilet repair & replacement': ShowerHead,
  'Drain cleaning': Waves,
  'Water heater installation': Flame,
  'Tankless water heater service': Flame,
  'Garbage disposal repair': Trash2,
  'Pipe replacement': Droplets,
  'Sewer line repair': Droplets,

  // HVAC Services
  'AC repair & installation': Snowflake,
  'Furnace repair': Flame,
  'HVAC maintenance': Thermometer,
  'Duct cleaning': Wind,
  'Thermostat installation': ThermometerSun,
  'Heat pump service': ThermometerSun,
  'Indoor air quality solutions': AirVent,
  'Vent repair': AirVent,

  // Cleaning Services
  'House cleaning': Sparkles,
  'Deep cleaning': Sparkles,
  'Move-in / move-out cleaning': Sparkles,
  'Office cleaning': Building,
  'Post-construction cleaning': Construction,
  'Carpet cleaning': LayoutGrid,
  'Upholstery cleaning': Armchair,
  'Window washing': GlassWater,
  'Pressure washing': Cloudy,

  // Flooring Services
  'Hardwood flooring': LayoutGrid,
  'Laminate installation': LayoutGrid,
  'Vinyl plank flooring': LayoutGrid,
  'Tile installation': LayoutGrid,
  'Carpet installation': LayoutGrid,
  'Floor refinishing': Brush,
  'Grout repair': PenTool,

  // Painting & Finishing
  'Interior painting': Paintbrush,
  'Exterior painting': PaintBucket,
  'Cabinet painting': Paintbrush,
  'Wallpaper installation': Palette,
  'Texture removal': Brush,
  'Deck staining': Paintbrush,
  'Fence painting': Fence,

  // Remodeling & Construction
  'Kitchen remodeling': Home,
  'Bathroom remodeling': ShowerHead,
  'Basement finishing': Warehouse,
  'Room additions': Building,
  'Garage conversions': Car,
  'Custom carpentry': Hammer,
  'Framing': Frame,
  'Demolition': HardHat,

  // Carpentry Services
  'Trim installation': Ruler,
  'Custom closets': DoorOpen,
  'Deck building': Layers,
  'Fence installation': Fence,
  'Pergola construction': Container,
  'Cabinet installation': Square,
  'Stair repair': Layers,

  // Roofing & Exterior
  'Roof repair': Building,
  'Roof replacement': Building,
  'Gutter cleaning': CloudRain,
  'Gutter installation': CloudRain,
  'Siding installation': PanelTop,
  'Soffit & fascia repair': Building,
  'Chimney repair': Flame,

  // Landscaping & Outdoor
  'Lawn care': Trees,
  'Gardening': Flower2,
  'Tree trimming': Scissors,
  'Tree removal': TreePine,
  'Irrigation systems': Droplets,
  'Sprinkler repair': Droplets,
  'Sod installation': Sprout,
  'Hardscaping': BrickWall,
  'Fence repair': Fence,

  // Doors, Windows & Glass
  'Window installation': PanelTop,
  'Window repair': PanelTop,
  'Door installation': DoorOpen,
  'Sliding door repair': DoorOpen,
  'Glass replacement': GlassWater,
  'Screen repair': Frame,

  // Masonry & Concrete
  'Concrete pouring': Cuboid,
  'Driveway repair': Mountain,
  'Patio installation': LayoutGrid,
  'Foundation repair': Cuboid,
  'Brick work': BrickWall,
  'Retaining walls': BrickWall,

  // Pest & Safety
  'Pest control': Bug,
  'Termite treatment': Bug,
  'Rodent removal': Rat,
  'Wildlife control': TreePine,
  'Mold remediation': Sparkles,
  'Radon testing': Search,
  'Home inspection': CheckSquare,

  // Security & Smart Home
  'Security camera installation': Camera,
  'Alarm systems': Shield,
  'Smart locks': Lock,
  'Home automation': Smartphone,
  'Network wiring': Network,
  'Wi-Fi optimization': Wifi,

  // Moving & Storage
  'Local moving': Truck,
  'Long-distance moving': Truck,
  'Packing services': Package,
  'Furniture moving': Sofa,
  'Storage solutions': ArchiveRestore,
  'Junk hauling': Trash2,

  // Specialty Services
  'Appliance repair': Cog,
  'Refrigerator repair': Refrigerator,
  'Washer/dryer service': WashingMachine,
  'Pool cleaning': Waves,
  'Pool repair': Waves,
  'Solar panel cleaning': SunMedium,
  'Insulation installation': Home,
  'Soundproofing': Volume2,

  // Junk Removal & Hauling
  'Trash removal': Trash2,
  'Construction debris removal': Construction,
  'Yard waste removal': Trees,
  'Furniture disposal': Sofa,
  'Garage cleanouts': Warehouse,

  // Installation Services
  'Appliance installation': Plug,
  'Home theater setup': MonitorSpeaker,

  // Legacy mappings (for backward compatibility)
  'Plumbing': Droplets,
  'Electrical': Zap,
  'Kitchen Renovation': Home,
  'Bathroom Renovation': ShowerHead,
  'Painting': Paintbrush,
  'General Repairs': Wrench,
  'Automotive': Car,
  'Landscaping': Trees,
};

/**
 * Get the icon component for a service or category name
 * @param {string} name - The name of the service or category
 * @param {boolean} isCategory - Whether this is a category (parent) or individual service
 * @returns {React.ComponentType} - The Lucide icon component
 */
export const getServiceIcon = (name, isCategory = false) => {
  if (!name) return Wrench;

  // Check category icons first if it's a category
  if (isCategory && CATEGORY_ICONS[name]) {
    return CATEGORY_ICONS[name];
  }

  // Check service icons
  if (SERVICE_ICONS[name]) {
    return SERVICE_ICONS[name];
  }

  // Try category icons as fallback
  if (CATEGORY_ICONS[name]) {
    return CATEGORY_ICONS[name];
  }

  // Partial match fallback for flexibility
  const lowerName = name.toLowerCase();

  if (lowerName.includes('electric')) return Zap;
  if (lowerName.includes('plumb')) return Droplets;
  if (lowerName.includes('paint')) return Paintbrush;
  if (lowerName.includes('clean')) return Sparkles;
  if (lowerName.includes('hvac') || lowerName.includes('air') || lowerName.includes('heat')) return Thermometer;
  if (lowerName.includes('roof')) return Building;
  if (lowerName.includes('floor')) return LayoutGrid;
  if (lowerName.includes('landscap') || lowerName.includes('lawn') || lowerName.includes('garden')) return Trees;
  if (lowerName.includes('secur') || lowerName.includes('alarm')) return Shield;
  if (lowerName.includes('moving') || lowerName.includes('pack')) return Truck;
  if (lowerName.includes('pest') || lowerName.includes('termite')) return Bug;
  if (lowerName.includes('door') || lowerName.includes('window')) return DoorOpen;
  if (lowerName.includes('concrete') || lowerName.includes('mason')) return Cuboid;
  if (lowerName.includes('carpent') || lowerName.includes('wood')) return Axe;
  if (lowerName.includes('remodel') || lowerName.includes('construct')) return Hammer;
  if (lowerName.includes('junk') || lowerName.includes('trash') || lowerName.includes('haul')) return Trash2;
  if (lowerName.includes('install')) return Plug;
  if (lowerName.includes('repair')) return Wrench;

  // Default fallback
  return Wrench;
};

/**
 * Get icon with services array (for API responses)
 * @param {Array} services - Array of service objects from API
 * @returns {Array} - Services array with icon property added
 */
export const addIconsToServices = (services) => {
  if (!Array.isArray(services)) return [];

  return services.map(service => ({
    ...service,
    icon: getServiceIcon(service.name, service.parent_id === null)
  }));
};

export default {
  CATEGORY_ICONS,
  SERVICE_ICONS,
  getServiceIcon,
  addIconsToServices,
};
